import { render, staticRenderFns } from "./PopupAISafetyMeasures.vue?vue&type=template&id=b47aa9e2&scoped=true"
import script from "./PopupAISafetyMeasures.vue?vue&type=script&lang=js"
export * from "./PopupAISafetyMeasures.vue?vue&type=script&lang=js"
import style0 from "./PopupAISafetyMeasures.vue?vue&type=style&index=0&id=b47aa9e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b47aa9e2",
  null
  
)

export default component.exports